module.exports = __webpack_public_path__ + "static/media/karma.5d9da521.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/karma.png
// module id = 131
// module chunks = 0